import {defineMessages} from 'react-intl'

export const brazilStateMessages = defineMessages({
    'state.br.acre': {
        id: 'state.br.acre',
        defaultMessage: 'Acre'
    },
    'state.br.alagoas': {
        id: 'state.br.alagoas',
        defaultMessage: 'Alagoas'
    },
    'state.br.amazonas': {
        id: 'state.br.amazonas',
        defaultMessage: 'Amazonas'
    },
    'state.br.amapa': {
        id: 'state.br.amapa',
        defaultMessage: 'Amapá'
    },
    'state.br.bahia': {
        id: 'state.br.bahia',
        defaultMessage: 'Bahia'
    },
    'state.br.ceara': {
        id: 'state.br.ceara',
        defaultMessage: 'Ceará'
    },
    'state.br.distritofederal': {
        id: 'state.br.distritofederal',
        defaultMessage: 'Distrito Federal'
    },
    'state.br.espiritosanto': {
        id: 'state.br.espiritosanto',
        defaultMessage: 'Espírito Santo'
    },
    'state.br.goias': {
        id: 'state.br.goias',
        defaultMessage: 'Goiás'
    },
    'state.br.maranhao': {
        id: 'state.br.maranhao',
        defaultMessage: 'Maranhão'
    },
    'state.br.minasgerais': {
        id: 'state.br.minasgerais',
        defaultMessage: 'Minas Gerais'
    },
    'state.br.matogrossodosul': {
        id: 'state.br.matogrossodosul',
        defaultMessage: 'Mato Grosso do Sul'
    },
    'state.br.matogrosso': {
        id: 'state.br.matogrosso',
        defaultMessage: 'Mato Grosso'
    },
    'state.br.para': {
        id: 'state.br.para',
        defaultMessage: 'Pará'
    },
    'state.br.paraiba': {
        id: 'state.br.paraiba',
        defaultMessage: 'Paraíba'
    },
    'state.br.pernambuco': {
        id: 'state.br.pernambuco',
        defaultMessage: 'Pernambuco'
    },
    'state.br.piaui': {
        id: 'state.br.piaui',
        defaultMessage: 'Piauí'
    },
    'state.br.parana': {
        id: 'state.br.parana',
        defaultMessage: 'Paraná'
    },
    'state.br.riodejaneiro': {
        id: 'state.br.riodejaneiro',
        defaultMessage: 'Rio de Janeiro'
    },
    'state.br.riograndedonorte': {
        id: 'state.br.riograndedonorte',
        defaultMessage: 'Rio Grande do Norte'
    },
    'state.br.rondonia': {
        id: 'state.br.rondonia',
        defaultMessage: 'Rondônia'
    },
    'state.br.roraima': {
        id: 'state.br.roraima',
        defaultMessage: 'Roraima'
    },
    'state.br.riograndedosul': {
        id: 'state.br.riograndedosul',
        defaultMessage: 'Rio Grande do Sul'
    },
    'state.br.santacatarina': {
        id: 'state.br.santacatarina',
        defaultMessage: 'Santa Catarina'
    },
    'state.br.sergipe': {
        id: 'state.br.sergipe',
        defaultMessage: 'Sergipe'
    },
    'state.br.saopaulo': {
        id: 'state.br.saopaulo',
        defaultMessage: 'São Paulo'
    },
    'state.br.tocantins': {
        id: 'state.br.tocantins',
        defaultMessage: 'Tocantins'
    }
})

export const brazilStateOptions = [
    {value: 'AC', label: 'state.br.acre'},
    {value: 'AL', label: 'state.br.alagoas'},
    {value: 'AM', label: 'state.br.amazonas'},
    {value: 'AP', label: 'state.br.amapa'},
    {value: 'BA', label: 'state.br.bahia'},
    {value: 'CE', label: 'state.br.ceara'},
    {value: 'DF', label: 'state.br.distritofederal'},
    {value: 'ES', label: 'state.br.espiritosanto'},
    {value: 'GO', label: 'state.br.goias'},
    {value: 'MA', label: 'state.br.maranhao'},
    {value: 'MG', label: 'state.br.minasgerais'},
    {value: 'MS', label: 'state.br.matogrossodosul'},
    {value: 'MT', label: 'state.br.matogrosso'},
    {value: 'PA', label: 'state.br.para'},
    {value: 'PB', label: 'state.br.paraiba'},
    {value: 'PE', label: 'state.br.pernambuco'},
    {value: 'PI', label: 'state.br.piaui'},
    {value: 'PR', label: 'state.br.parana'},
    {value: 'RJ', label: 'state.br.riodejaneiro'},
    {value: 'RN', label: 'state.br.riograndedonorte'},
    {value: 'RO', label: 'state.br.rondonia'},
    {value: 'RR', label: 'state.br.roraima'},
    {value: 'RS', label: 'state.br.riograndedosul'},
    {value: 'SC', label: 'state.br.santacatarina'},
    {value: 'SE', label: 'state.br.sergipe'},
    {value: 'SP', label: 'state.br.saopaulo'},
    {value: 'TO', label: 'state.br.tocantins'}
]
